export const qualityMetricsInfo = {
  200: {
    loadingExperience: {
      id: 'https://www.google.com/',
      metrics: {
        CUMULATIVE_LAYOUT_SHIFT_SCORE: {
          percentile: 4,
          distributions: [
            {
              min: 0,
              max: 10,
              proportion: 0.9607,
            },
            {
              min: 10,
              max: 25,
              proportion: 0.0239,
            },
            {
              min: 25,
              proportion: 0.0154,
            },
          ],
          category: 'FAST',
        },
        EXPERIMENTAL_TIME_TO_FIRST_BYTE: {
          percentile: 530,
          distributions: [
            {
              min: 0,
              max: 800,
              proportion: 0.858,
            },
            {
              min: 800,
              max: 1800,
              proportion: 0.1051,
            },
            {
              min: 1800,
              proportion: 0.0369,
            },
          ],
          category: 'FAST',
        },
        FIRST_CONTENTFUL_PAINT_MS: {
          percentile: 1015,
          distributions: [
            {
              min: 0,
              max: 1800,
              proportion: 0.9027,
            },
            {
              min: 1800,
              max: 3000,
              proportion: 0.0602,
            },
            {
              min: 3000,
              proportion: 0.0371,
            },
          ],
          category: 'FAST',
        },
        INTERACTION_TO_NEXT_PAINT: {
          percentile: 253,
          distributions: [
            {
              min: 0,
              max: 200,
              proportion: 0.6517,
            },
            {
              min: 200,
              max: 500,
              proportion: 0.2681,
            },
            {
              min: 500,
              proportion: 0.0802,
            },
          ],
          category: 'AVERAGE',
        },
        LARGEST_CONTENTFUL_PAINT_MS: {
          percentile: 1247,
          distributions: [
            {
              min: 0,
              max: 2500,
              proportion: 0.923,
            },
            {
              min: 2500,
              max: 4000,
              proportion: 0.0468,
            },
            {
              min: 4000,
              proportion: 0.0303,
            },
          ],
          category: 'FAST',
        },
      },
      overall_category: 'AVERAGE',
      initial_url: 'https://www.google.com/?gws_rd=ssl',
    },
    originLoadingExperience: {
      id: 'https://www.google.com',
      metrics: {
        CUMULATIVE_LAYOUT_SHIFT_SCORE: {
          percentile: 0,
          distributions: [
            {
              min: 0,
              max: 10,
              proportion: 0.9679,
            },
            {
              min: 10,
              max: 25,
              proportion: 0.0131,
            },
            {
              min: 25,
              proportion: 0.0191,
            },
          ],
          category: 'FAST',
        },
        EXPERIMENTAL_TIME_TO_FIRST_BYTE: {
          percentile: 267,
          distributions: [
            {
              min: 0,
              max: 800,
              proportion: 0.9468,
            },
            {
              min: 800,
              max: 1800,
              proportion: 0.0343,
            },
            {
              min: 1800,
              proportion: 0.0189,
            },
          ],
          category: 'FAST',
        },
        FIRST_CONTENTFUL_PAINT_MS: {
          percentile: 626,
          distributions: [
            {
              min: 0,
              max: 1800,
              proportion: 0.9531,
            },
            {
              min: 1800,
              max: 3000,
              proportion: 0.0274,
            },
            {
              min: 3000,
              proportion: 0.0195,
            },
          ],
          category: 'FAST',
        },
        INTERACTION_TO_NEXT_PAINT: {
          percentile: 189,
          distributions: [
            {
              min: 0,
              max: 200,
              proportion: 0.7661,
            },
            {
              min: 200,
              max: 500,
              proportion: 0.166,
            },
            {
              min: 500,
              proportion: 0.0678,
            },
          ],
          category: 'FAST',
        },
        LARGEST_CONTENTFUL_PAINT_MS: {
          percentile: 898,
          distributions: [
            {
              min: 0,
              max: 2500,
              proportion: 0.9542,
            },
            {
              min: 2500,
              max: 4000,
              proportion: 0.0258,
            },
            {
              min: 4000,
              proportion: 0.02,
            },
          ],
          category: 'FAST',
        },
      },
      overall_category: 'FAST',
      initial_url: 'https://www.google.com/?gws_rd=ssl',
    },
    aspect_scores: {
      performance: 0.91,
      seo: 0.83,
      accessibility: 0.85,
      'best-practices': 0.83,
    },
    aspect_details: {
      performance: {
        'first-contentful-paint': {
          id: 'first-contentful-paint',
          title: 'First Contentful Paint',
          description:
            'First Contentful Paint marks the time at which the first text or image is painted. [Learn more about the First Contentful Paint metric](https://developer.chrome.com/docs/lighthouse/performance/first-contentful-paint/).',
          score: 0.51,
          scoreDisplayMode: 'numeric',
          displayValue: '2.9 s',
          numericValue: 2941.0025196795877,
          numericUnit: 'millisecond',
          speedCategory: 'average',
        },
        'total-blocking-time': {
          id: 'total-blocking-time',
          title: 'Total Blocking Time',
          description:
            'Sum of all time periods between FCP and Time to Interactive, when task length exceeded 50ms, expressed in milliseconds. [Learn more about the Total Blocking Time metric](https://developer.chrome.com/docs/lighthouse/performance/lighthouse-total-blocking-time/).',
          score: 0.92,
          scoreDisplayMode: 'numeric',
          displayValue: '180 ms',
          numericValue: 178.5,
          numericUnit: 'millisecond',
          speedCategory: 'fast',
        },
        'speed-index': {
          id: 'speed-index',
          title: 'Speed Index',
          description:
            'Speed Index shows how quickly the contents of a page are visibly populated. [Learn more about the Speed Index metric](https://developer.chrome.com/docs/lighthouse/performance/speed-index/).',
          score: 0.94,
          scoreDisplayMode: 'numeric',
          displayValue: '2.9 s',
          numericValue: 2941.0025196795877,
          numericUnit: 'millisecond',
          speedCategory: 'fast',
        },
        'cumulative-layout-shift': {
          id: 'cumulative-layout-shift',
          title: 'Cumulative Layout Shift',
          description:
            'Cumulative Layout Shift measures the movement of visible elements within the viewport. [Learn more about the Cumulative Layout Shift metric](https://web.dev/articles/cls).',
          score: 1,
          scoreDisplayMode: 'numeric',
          displayValue: '0',
          details: {
            type: 'debugdata',
            items: [
              {
                newEngineResult: {
                  cumulativeLayoutShift: 0,
                  cumulativeLayoutShiftMainFrame: 0,
                },
                cumulativeLayoutShiftMainFrame: 0,
                newEngineResultDiffered: false,
              },
            ],
          },
          numericValue: 0,
          numericUnit: 'unitless',
          speedCategory: 'fast',
        },
        'largest-contentful-paint': {
          id: 'largest-contentful-paint',
          title: 'Largest Contentful Paint',
          description:
            'Largest Contentful Paint marks the time at which the largest text or image is painted. [Learn more about the Largest Contentful Paint metric](https://developer.chrome.com/docs/lighthouse/performance/lighthouse-largest-contentful-paint/)',
          score: 0.79,
          scoreDisplayMode: 'numeric',
          displayValue: '2.9 s',
          numericValue: 2941.0025196795877,
          numericUnit: 'millisecond',
          speedCategory: 'average',
        },
      },
    },
    strategy: 'MOBILE',
  },
};
